export default{
    title: 'Calendar',
    sync: 'Sync Google Calendar',
    stop: 'Stop syncing',
    settings: 'Settings',
    activeSync: 'Active syncing with',
    syncPaused: 'Syncing has stopped. Please re-authorize the calendar by clicking the following link.',
    notFunctioning: 'If the syncing has stopped,',
    googleNoEdit: 'This event can only be changed in Google Calendar.',

    edit:'Edit appointment',
    add: 'Create new appointment',
    cancelled: 'Cancelled appointment'
}
